import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { UserIcon } from 'lucide-react';

const ManagerHeader: React.FC = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const fakeUser = {
    name: 'Bruno Darolt',
    avatar: '/default_user.png', // Substitua por uma imagem padrão de usuário sem foto
  };

  return (
    <div className="w-full bg-white border-b border-gray-100">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center">
          <img src="/santogram_logo.png" alt="SantoGram" className="w-20 h-20 object-contain" />
        </div>

        <div className="flex items-center space-x-3 relative">
          <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center">
            <UserIcon className="w-6 h-6 text-gray-500" />
          </div>
          <button
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            className="flex items-center space-x-2 text-gray-700"
          >
            <span className="font-semibold">{fakeUser.name}</span>
            {isDropdownOpen ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
          </button>

          {isDropdownOpen && (
            <div className="absolute right-0 top-full mt-1 w-40 bg-white border border-gray-100 shadow-sm rounded-md py-1 z-10">
              <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">Configurações</button>
              <button className="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">Meu perfil</button>
              <button className="w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-50">Sair</button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManagerHeader;


